import { FaRandom } from "react-icons/fa";

const ShuffleIcon = () => <FaRandom size={24} />;
export default ShuffleIcon;